import './OutsideClick.scss';

import * as React from 'react';
import { addEventListener } from 'consolidated-events';

interface IOutsideClickProps {
    children?: React.ReactNode;
    onOutsideClick: (event: MouseEvent) => void;
}

class OutsideClick extends React.Component<IOutsideClickProps, any> {
    private container: HTMLDivElement | null = null;
    private removeEventListener: (() => void) | undefined;

    constructor(props: IOutsideClickProps) {
        super(props);

        this.onOutsideClick = this.onOutsideClick.bind(this);
    }

    override componentDidMount() {
        // `capture` flag is set to true so that a `stopPropagation` in the children
        // will not prevent all outside click handlers from firing - maja
        this.removeEventListener = addEventListener(
            document,
            'click',
            this.onOutsideClick,
            { capture: true },
        );
    }

    onOutsideClick(event: MouseEvent) {
        const { onOutsideClick } = this.props;

        const isDescendantOfRoot = this.container && this.container.contains(event.target as Node);

        if (!isDescendantOfRoot) {
            onOutsideClick(event);
        }
    }

    override componentWillUnmount() {
        if (this.removeEventListener) { this.removeEventListener(); }
    }

    override render() {
        const { children } = this.props;

        return <div ref={ref => { this.container = ref; }}>
            {children}
        </div>
    }
}
export default OutsideClick
